export default {
  all: 'All',
  ok: 'OK',
  cancel: 'Cancel',
  clear: 'Clear',
  placeholder: 'Search...',
  label: 'Name',
};
